export default __webpack_public_path__ + "static/media/doubleClickForm.d5590786.svg";